/**
 * app.direct130.com: Direct 130's white-labeled CRM, served by this app on its own address. The agency whose
 * custom domain it is supplies the name, logo and colors. Agents there sign in through their Direct 130
 * account (the Direct 130 server hands back a one-time sign-in, see the backend's direct130-partner
 * controller) and never sign up here; the address has no agency dashboard, lead assignment, rewards or
 * forum. The hosts come from NEXT_PUBLIC_DIRECT130_HOSTS (comma separated) so staging can use its own.
 */
const DEFAULT_DIRECT130_HOSTS = ["app.direct130.com"];

/** Direct 130's sign-in. next=crm brings an approved agent straight back here, signed in. */
export const DIRECT130_SIGN_IN_URL =
  process.env.NEXT_PUBLIC_DIRECT130_SIGN_IN_URL || "https://www.direct130.com/login?next=crm";

/** Accounts come from the Direct 130 application, never a sign-up here. */
export const DIRECT130_APPLY_URL = process.env.NEXT_PUBLIC_DIRECT130_APPLY_URL || "https://www.direct130.com/apply";

/** Sidebar entries the Direct 130 address drops: the agency tools, and InsuraCentral's other products and programs. */
export const DIRECT130_HIDDEN_NAV = new Set([
  "/agency-dashboard",
  "/lead-assignment",
  "/agent-rewards",
  "/lead-sniper",
  "/campaigns",
  "/ai-calling",
  "/training",
  "/forum",
  "/team-chat", // owner 2026-11-01: no team chat on Direct130
]);

export function direct130Hosts(): string[] {
  const raw = process.env.NEXT_PUBLIC_DIRECT130_HOSTS;
  return (raw ? raw.split(",") : DEFAULT_DIRECT130_HOSTS).map((h) => h.trim().toLowerCase()).filter(Boolean);
}

export function isDirect130Host(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== "undefined" ? window.location.hostname : "")).toLowerCase();
  return !!host && direct130Hosts().includes(host);
}

/** Direct 130's sign-in screens (the sign-in card and its 2FA step) share www.direct130.com's teal button. */
export const DIRECT130_BUTTON =
  "flex min-h-[46px] w-full items-center justify-center rounded-lg border border-[#236b70] bg-[#236b70] px-5 text-[15px] font-medium text-white no-underline shadow-[0_3px_0_#15464e] transition-[transform,box-shadow,background-color] hover:-translate-y-0.5 hover:bg-[#1b555d] hover:shadow-[0_5px_0_#15464e] active:translate-y-0.5 active:shadow-[0_1px_0_#15464e] focus-visible:!outline-solid focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-[#236b70] motion-reduce:transition-none motion-reduce:hover:translate-y-0";
/** The small boxed secondary action (owner 2026-11-01: no underlined text on Direct130): outlined, teal text, fills on hover. */
export const DIRECT130_BOX =
  "inline-flex min-h-[44px] shrink-0 items-center justify-center rounded-lg border border-[#d8e3df] bg-white px-3.5 text-[14px] font-medium text-[#236b70] no-underline transition-colors hover:border-[#236b70] hover:bg-[#f2f6f4] focus-visible:!outline-solid focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-[#236b70]";
